import { SVGInterface } from "../../interface";

const ArrowSolidRight = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path d="M9.5 17L14.5 12L9.5 7V17Z" fill={color || "#0E171F"} />
  </svg>
);

export default ArrowSolidRight;
